import * as Types from '../../../graphql.generated';

export type UserWithTrackedPropertiesFragment = { __typename?: 'User' } & Pick<
    Types.User,
    | 'loggedIn'
    | 'name'
    | 'email'
    | 'status'
    | 'senderPropertyStatus'
    | 'userId'
    | 'userUuid'
    | 'creationDate'
    | 'brandPrimary'
    | 'registrationSources'
    | 'registered'
> & {
        profile?: Types.Maybe<
            { __typename?: 'UserProfile' } & Pick<
                Types.UserProfile,
                'situationWhatIsYourCurrentPropertyGoal'
            >
        >;
        nextBestAction?: Types.Maybe<
            { __typename?: 'NextBestActions' } & {
                actions: Array<
                    { __typename?: 'NextBestAction' } & Pick<
                        Types.NextBestAction,
                        'action'
                    > & {
                            extraDetails?: Types.Maybe<
                                {
                                    __typename?: 'NextBestActionUpdateYourSituationExtraDetails';
                                } & Pick<
                                    Types.NextBestActionUpdateYourSituationExtraDetails,
                                    'updateYourSituationType'
                                >
                            >;
                        }
                >;
            }
        >;
        trackedProperties?: Types.Maybe<
            { __typename?: 'UserTrackedProperties' } & Pick<
                Types.UserTrackedProperties,
                'total'
            > & {
                    items: Array<
                        { __typename?: 'UserTrackedProperty' } & Pick<
                            Types.UserTrackedProperty,
                            'relationship'
                        > & {
                                property: { __typename?: 'Property' } & Pick<
                                    Types.Property,
                                    'uprn'
                                > & {
                                        address?: Types.Maybe<
                                            { __typename?: 'Address' } & Pick<
                                                Types.Address,
                                                'fullAddress' | 'uprn'
                                            >
                                        >;
                                    };
                                permissions?: Types.Maybe<
                                    { __typename?: 'Permissions' } & Pick<
                                        Types.Permissions,
                                        'hasPermissions'
                                    >
                                >;
                            }
                    >;
                }
        >;
    };

export const UserWithTrackedPropertiesFragmentDoc = `
    fragment UserWithTrackedProperties on User {
  loggedIn
  name
  email
  status
  senderPropertyStatus
  userId
  userUuid
  creationDate
  brandPrimary
  registrationSources
  registered
  profile {
    situationWhatIsYourCurrentPropertyGoal
  }
  nextBestAction(context: AUTH) {
    actions {
      action
      extraDetails {
        ... on NextBestActionUpdateYourSituationExtraDetails {
          updateYourSituationType
        }
      }
    }
  }
  trackedProperties(offset: 0, limit: 1) {
    total
    items {
      relationship
      property {
        uprn
        address {
          fullAddress
          uprn
        }
      }
      permissions {
        hasPermissions
      }
    }
  }
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {};
}
export type Sdk = ReturnType<typeof getSdk>;
